import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BookingInfoProperties, BookingPassengerInfoProperties, SectorInformationProperties, TaxDetailsProperties, TravelPreference_ServiceType, TravelPreference_MealList, TravelPreference_SeatList, PassengerCreationResponse, GetAllBookingServicesProperties, MealAirArabiaProperties } from '../Models/BookingPassengerTicketIssuanceProperties';
import { Countries, CountryMasterResponse } from '../Models/Countries';
import { BookingBasicProperties, FlightSearchDestinationProperties } from '../Models/FlightSearchProperties';
import { FlightSearchScreenRights } from '../Models/FlightSearchResponseProperties';
import { PaymentRightsProperties } from '../models/PaymentProperties';
import { PassengerProfile } from '../Models/BookingPassengerTicketIssuanceProperties';
@Injectable({
  providedIn: 'root'
})
export class PassengerInfoService {
  baseUrl = environment.baseUrl;
  public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject(false);
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }
  modifyBookingPassengerInfoRecord(bookingObj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/FlightSearch/ModifyBookingPassenger', bookingObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  createBookingPassengerInfoRecord(bookingObj): Observable<PassengerCreationResponse> {
    this.showSpinner.next(true);
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/FlightSearch/BookGalileoFlight', bookingObj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
  createModifyBookingPassengerInfoRecord(bookingObj): Observable<PassengerCreationResponse> {
    this.showSpinner.next(true);
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/FlightSearch/ModifyBookGalileoFlight', bookingObj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
  //.pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  //----------------------------- Countries List ----------------------------

  getCountries(): Observable<Countries[]> {
    return this.http.get<Countries[]>(this.baseUrl + '/PassengerInfo/GetAllCountries')
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getCountriesWithCitiesForInsurance(): Observable<CountryMasterResponse> {
    return this.http
      .get<CountryMasterResponse>(this.baseUrl + '/PassengerInfo/GetAllCountriesWithCitiesForInsurance')
      .pipe(
        catchError(error => throwError(error))
      );
  }
  //------------------------------TravelPreferences--------------------------

  //------------------------------TravelPreferences--------------------------

  //getServiceType(): Observable<TravelPreference_ServiceType[]> {
  //  return this.http.get<TravelPreference_ServiceType[]>(this.baseUrl + '/PassengerInfo/GetTravelPreferenceServiceType')
  //    .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  //}
  //getFlyerCountry(): Observable<TravelPreferences[]> {
  //  return this.http.get<TravelPreferences[]>(this.baseUrl + '/PassengerInfo/GetTravelPreferenceFlyerCountry')
  //    .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  //}
  //getMealList(): Observable<TravelPreference_MealList[]> {
  //  return this.http.get<TravelPreference_MealList[]>(this.baseUrl + '/PassengerInfo/GetTravelPreferenceMealList')
  //    .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  //}
  //getSeatList(): Observable<TravelPreference_SeatList[]> {
  //  return this.http.get<TravelPreference_SeatList[]>(this.baseUrl + '/PassengerInfo/GetTravelPreferenceSeatList')
  //    .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  //}
  getAirportsByCode(obj): Observable<FlightSearchDestinationProperties[]> {
    return this.http.post<FlightSearchDestinationProperties[]>(this.baseUrl + '/PassengerInfo/GetAirportsByCityCode', JSON.stringify(obj), this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getAllBookingServicesData(): Observable<GetAllBookingServicesProperties> {
    return this.http.get<GetAllBookingServicesProperties>(this.baseUrl + '/PassengerInfo/GetBookingServicesBaseData', this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  CheckAgentBookRightAgainstAgencyAndUserId(param, isAgency): Observable<FlightSearchScreenRights> {
    return this.http.get<FlightSearchScreenRights>(this.baseUrl + '/FlightSearch/GetAgentBookRightAganistAgencyAndUserId/' + param + "/" + isAgency)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  CheckPaymentRights(agencyId, userId): Observable<PaymentRightsProperties> {
    return this.http.get<PaymentRightsProperties>(this.baseUrl + '/Payment/CheckPaymentRightAgainstAgencyAndUserId/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  emailBooking(bookingEmailObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/EmailItinerary/SendBookingEmail', bookingEmailObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  GetPassengerProfileSearch(ctcno): Observable<PassengerProfile[]> {
    return this.http.post<PassengerProfile>(this.baseUrl + '/PassengerProfiling/PassengerProfileSearchByCtcNo', ctcno, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetBookingDetails(bookingidobj, agencyid): Observable<BookingPassengerInfoProperties[]> {
    return this.http.get<BookingPassengerInfoProperties[]>(this.baseUrl + '/PassengerInfo/Getbookingdetails/' + bookingidobj + '/' + agencyid, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        console.log(error);
        return throwError(error);
      }))
  }
  getMealsAirArabiaDetails(obj): Observable<MealAirArabiaProperties> {
    return this.http.post<MealAirArabiaProperties>(this.baseUrl + '/FlightSearch/GetMealDeatilsListByAirArabia', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))

  }
  flightAirsialCheckCountryName(bookingidobj): Observable<boolean> {
    return this.http.post<MealAirArabiaProperties>(this.baseUrl + '/PassengerInfo/AirsialdestinationFind', bookingidobj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))


  }

  CreateBookingGroupTicket(bookingObj): Observable<PassengerCreationResponse> {
    this.showSpinner.next(true);
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/FlightSearch/BookGroupFlight', bookingObj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
  GetANCIofAllFlights(obj): Observable<BookingBasicProperties> {
    return this.http.post<BookingBasicProperties>(this.baseUrl + '/FlightSearch/GetANCIofAllFlights', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))

  }
  getSeatForFZModification(obj): Observable<MealAirArabiaProperties> {
    return this.http.post<MealAirArabiaProperties>(this.baseUrl + '/FlightSearch/GetSeatForFZModification', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))

  }
}
